import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, input, model, output, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { ParticipanteAta, SituacaoPresencaAta } from '@/features/comissoes/dashboard-comissoes/comissoes-dashboard.model';
import { OpcaoPresencaAta, TipoParticipanteAta, classeSituacaoAta, iconeSituacaoAta, mapearOpcaoParaSituacaoAta } from '../ata-reuniao.presenter';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
/** Diálogo de alteração da presença/função de um participante (membro ou convidado). */
@Component({
    selector: 'app-ata-dialog-presenca',
    standalone: true,
    imports: [DialogoPadraoDirective, CommonModule, ButtonModule, DialogModule, CanDirective],
    templateUrl: './ata-dialog-presenca.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AtaDialogPresencaComponent implements OnChanges {
    /** Visibilidade do diálogo (two-way). */
    readonly visivel = model(false);
    /** Participante em edição. */
    readonly participante = input<ParticipanteAta | null>(null);
    /** Papel do participante (rótulo Membro/Convidado). */
    readonly tipo = input<TipoParticipanteAta>('M');
    /** Opções de presença/função exibidas. */
    readonly opcoes = input<OpcaoPresencaAta[]>([]);
    /** Valor de presença atual (pré-seleciona ao abrir). */
    readonly valorInicial = input('');
    /** Emite o código de presença/função escolhido. */
    readonly confirmar = output<string>();

    protected readonly selecionado = signal('');
    protected readonly roleGerenciarConvidados = PERMISSOES.comissoes.atas.gerenciarConvidados;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visivel'] && this.visivel()) {
            this.selecionado.set(this.valorInicial());
        }
    }

    protected icone(situacao: SituacaoPresencaAta): string {
        return iconeSituacaoAta(situacao);
    }

    protected classe(situacao: SituacaoPresencaAta): string {
        return classeSituacaoAta(situacao);
    }

    protected situacaoDaOpcao(value: string): SituacaoPresencaAta {
        return mapearOpcaoParaSituacaoAta(value);
    }

    protected escolher(value: string): void {
        this.selecionado.set(value);
    }

    protected fechar(): void {
        this.visivel.set(false);
    }

    protected aoConfirmar(): void {
        this.confirmar.emit(this.selecionado());
        this.fechar();
    }
}
